module.exports = __webpack_public_path__ + "img/cz.68fc25a.webp";